<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><a id="piii"></a><em>To all American service members<br/>past, present, and future.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780811740111_epub_ded_r1.vue?c34e623a